import cx from 'classnames'
import { useRef, useState } from 'react'

import { useClickOutside } from '../../../hooks/useClickOutside'
import { prepareName } from '../../igao/utils'

import styles from './selectRelations.module.scss'

const SelectRelations = ({ setQuestion, question, inputRef, lists }) => {
  const [ entityView, setEntityView ] = useState(false)
  const wrapperRef = useRef(null)
  useClickOutside(wrapperRef, () => {
    setEntityView(false)
  })
  const handleSelectRelation = key => {
    setQuestion(prev => {
      const tempQuestion = {
        ...prev,
        template: prev.template
          ? `${prev.template} {${key}}`.replace(/\s\s+/g, ' ')
          : `{${key}}`
      }

      inputRef.current.focus()
      setEntityView(false)
      return tempQuestion
    })
  }

  const handleEntry = () => {
    setEntityView(!entityView)
  }

  const disabled = rel =>
    question.template && question?.template?.indexOf(`{${rel.name}}`) !== -1

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => handleEntry()}
        style={{
          all: 'unset',
          cursor: 'pointer',
          position: 'absolute',
          right: '8px',
          top: '-38px',
          color: '#7728fe',
          fontWeight: '500',
          border: '2px solid rgb(119,40,254)',
          borderRadius: '4px',
          padding: '7px 12px',
          fontSize: '12px'
        }}
      >
        + ENTITY
      </button>
      <div
        className={styles.itemsWrapper}
        ref={wrapperRef}
      >
        {entityView && (
          <div
            className={styles.items}
            style={{
              right: 0,
              top: 0,
              maxWidth: '225px',
              marginLeft: 'auto'
            }}
          >
            {lists?.relations.map(rel => (
              <button
                className={cx(styles.selectItem, {
                  [styles.disabled]: disabled(rel)
                })}
                key={rel.id}
                style={{ padding: '12px' }}
                onClick={() => !disabled(rel) && handleSelectRelation(rel.name)}
              >
                <div
                  className={styles.text}
                  style={{ width: '100%' }}
                >
                  {prepareName(rel.name)}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default SelectRelations
